export default {
  common: {
    categories: {
      emergencies: {
        name: "Numéros d'urgences",
        contacts: [
          {
            name: 'Urgence générale',
            tel: '112'
          },
          {
            name: 'Ambulance, médecins',
            tel: '061'
          },
          {
            name: 'Guardia civile',
            tel: '062'
          },
          {
            name: 'Police',
            tel: '091'
          },
          {
            name: 'Pompiers',
            tel: '080'
          },
          {
            name: 'Centre antipoison',
            tel: '91 562 04 20'
          },
        ]
      },
    }
  },


  costa_blanca: {
    name: 'Costa Blanca',
    categories: {
      police: {
        name: 'Police',
        contacts: [
          {
            name: 'Urgences / Police',
            tel: '112'
          },
          {
            name: 'Protection civile',
            tel: '966 769 143 / 966 760 000'
          },
          {
            name: 'Police locale',
            tel: '649 900 304'
          },
        ]
      },
      health: {
        name: 'Santé',
        contacts: [
          {
            name: 'Croix rouge',
            tel: '965 171 818'
          },
          {
            name: 'Ambulance',
            tel: '965 144 000'
          },
          {
            name: 'Hopital de Torrevieja',
            tel: '965 72 12 00',
            address: 'Carretera CV 95, s/n (Sortie d´autoroute Orihuela – Torrevieja sud)',
            zip: '03186',
            city: 'Torrevieja'
          },
          {
            name: 'Hopital Quirón (Privé)',
            tel: ' : 966 921 313',
            address: 'Partida de la Loma, s/n',
            zip: '03184',
            city: 'Torrevieja'
          },
        ]
      },
      fire: {
        name: 'Pompiers',
        contacts: [
          {
            name: 'Pompiers',
            tel: '965 300 080/085'
          },
        ]
      },
    }
  },


  costa_sol: {
    name: 'Costa del Sol',
    categories: {
      police: {
        name: 'Police',
        contacts: [
          {
            name: 'Urgences / Police',
            tel: '112'
          },
          {
            name: 'Protection civile',
            tel: '062'
          },
          {
            name: 'Police locale',
            tel: '092'
          },
        ]
      },
      health: {
        name: 'Santé',
        contacts: [
          {
            name: 'Croix rouge',
            tel: '902 222 292'
          },
          {
            name: 'Ambulance',
            tel: '061'
          },
          {
            name: 'Regional Carlos Haya Hospital',
            tel: '951 030 100',
            address: 'Av. de Carlos Haya, s/n',
            zip: '29010',
            city: 'Málaga'
          },
          {
            name: 'Hôpital  Universitaire Virgen de la Victoria',
            tel: '951 032 000',
            address: 'Campus de Teatinos, S/N',
            zip: ', 29010',
            city: 'Málaga'
          },
          {
            name: 'Hospital Costa Del Sol',
            tel: '951 976 669',
            address: 'A-7, Km 187',
            zip: '29603',
            city: 'Marbella'
          },
        ]
      },
      fire: {
        name: 'Pompiers',
        contacts: [
          {
            name: 'Pompiers',
            tel: '080'
          },
        ]
      },
    }
  },


  costa_almeria: {
    name: 'Costa Almeria',
    categories: {
      police: {
        name: 'Police',
        contacts: [
          {
            name: 'Urgences / Police',
            tel: '112'
          },
          {
            name: 'Protection civile',
            tel: '950 464 024'
          },
          {
            name: 'Police locale',
            tel: '950 465 049'
          },
        ]
      },
      health: {
        name: 'Santé',
        contacts: [
          {
            name: 'Croix rouge',
            tel: '950 624 549'
          },
          {
            name: 'Ambulance',
            tel: '968 448 895'
          },
          {
            name: 'Centre de soins',
            tel: '902 505 060 et 950 474 734',
            address: 'Avda. Andalucía N° 87',
            zip: '04640',
            city: 'Pulpi'
          },
          {
            name: 'Hôpital Público Comarcal La Inmaculada',
            tel: '950 029 000',
            address: 'Av. Dtra Ana Parra Hospital San Isidro, s/n',
            zip: '04600',
            city: 'Huércal-Overa'
          },
        ]
      },
      fire: {
        name: 'Pompiers',
        contacts: [
          {
            name: 'Pompiers',
            tel: '950 479 000'
          },
        ]
      },
    }
  },


  costa_calida: {
    name: 'Costa Calida',
    categories: {
      police: {
        name: 'Police',
        contacts: [
          {
            name: 'Urgences / Police',
            tel: '112'
          },
          {
            name: 'Protection civile',
            tel: '968 335920'
          },
          {
            name: 'Police locale',
            tel: '968 171919'
          },
        ]
      },
      health: {
        name: 'Santé',
        contacts: [
          {
            name: 'Hospital General Universitario Santa Lucia',
            tel: '968 12 86 00',
            address: 'Calle Mezquita, s/n',
            zip: '30202',
            city: 'Cartagena, Murcia'
          },
        ]
      },
      fire: {
        name: 'Pompiers',
        contacts: [
          {
            name: 'Pompiers',
            tel: '968 128880'
          },
        ]
      },
    }
  }
};


// WEBPACK FOOTER //
// ./src/data/emergency_contacts.js